import type { AlgoliaProduct } from "@lib/wrappers/algolia";
import { normalizeAlgoliaProducts } from "@lib/wrappers/algolia";
import type { BaseHit, Hit } from "instantsearch.js";
import { useInfiniteHits } from "react-instantsearch";

interface NormalizedInfiniteHits {
    hits: Hit<BaseHit>[];
    numberOfHits: number;
    resultQuery: string;
    isFirstPage: boolean;
    isLastPage: boolean;
    currentPageHits: AlgoliaProduct[];
}

export function useNormalizedInfiniteHits(): NormalizedInfiniteHits {
    const { hits, currentPageHits, results, isFirstPage, isLastPage } = useInfiniteHits();

    return {
        hits,
        numberOfHits: results.nbHits,
        resultQuery: results.query,
        isFirstPage,
        isLastPage,
        currentPageHits: normalizeAlgoliaProducts(currentPageHits as unknown as AlgoliaProduct[]),
    };
}
